export default "__VITE_ASSET__CU1E2VKy__"